var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpiredInvitation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 157,
    viewBox: "0 0 157 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.4177 13.0835H105.583L143.917 51.4177V105.583L105.583 143.917H51.4177L13.0835 105.583V51.4177L51.4177 13.0835Z",
    stroke: "#55595F",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5 52.3335V78.5002",
    stroke: "#55595F",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5 104.667H78.5643",
    stroke: "#55595F",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiredInvitation);
export default __webpack_public_path__ + "static/media/ExpiredInvitation.06495b933a0da4bdf95f0b6c933c221e.svg";
export { ForwardRef as ReactComponent };